// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import { useState, useEffect } from "react";
import ConsultationForm from "../../ConsultationProgram/ConsultationForm";
import AnimatedBackground from "./AnimatedBackground";

import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import PublicNavbar from "../../../devComponents/Navbars/PublicNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Presentation page sections
import TheThreePrincipals from "./sections/TheThreePrincipals";
import DesignBlocks from "./sections/DesignBlocks";
import OdooPartner from "./sections/OdooPartner";
import Information from "./sections/Information";
import Pages from "pages/Presentation/sections/Pages";
import Footer from "./sections/Download";

// Presentation page components

import footerRoutes from "footer.routes";
import { useNavigate } from "react-router-dom";
import MKButton from "components/MKButton";
import AnimatedLogo from "components/AnimatedLogo";
import CaseStudies from "./sections/CaseStudies";

// Images
// import bgImage from "assets/images/bg-presentation.jpg";
// background video removed — using gradient/overlay instead

function Presentation() {
  let navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    if (open) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [open]);

  // Listen for global event to open consultation modal
  useEffect(() => {
    const handleOpen = () => setOpen(true);
    window.addEventListener("openConsultation", handleOpen);
    return () => window.removeEventListener("openConsultation", handleOpen);
  }, []);

  const closeModal = () => {
    try {
      sessionStorage.setItem("consultation_shown", "1");
    } catch (e) {}
    setOpen(false);
  };

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <MKBox
      sx={{
        background: `
          radial-gradient(ellipse at 15% 55%, rgba(78,137,255,0.18) 0%, transparent 55%),
          radial-gradient(ellipse at 85% 15%, rgba(130,40,220,0.14) 0%, transparent 50%),
          radial-gradient(ellipse at 65% 85%, rgba(200,30,30,0.10) 0%, transparent 45%),
          linear-gradient(150deg, #06091a 0%, #0d0b2a 55%, #080d1a 100%)
        `,
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <div style={{ position: "relative", zIndex: 1 }}>
        <MKBox
          data-ring="dark"
          minHeight="100vh"
          width="100%"
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            pt: { xs: "80px", md: "72px" },
            pb: { xs: "64px", md: "80px" },
          }}
        >
          <PublicNavbar />
          <AnimatedBackground />
          <Container
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              justifyContent="center"
              mx="auto"
              textAlign="center"
              sx={{ px: { xs: 2, sm: 3 }, mt: { xs: -4, md: -6 } }}
            >
              <Grid item xs={12} lg={8}>
                <Box
                  sx={{
                    px: { xs: 3, sm: 4, md: 6 },
                    py: { xs: 0, sm: 2, md: 2 },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <AnimatedLogo
                    style={{ width: 200, height: 200, marginBottom: 8 }}
                  />

                  <MKTypography
                    variant="h1"
                    color="white"
                    sx={{
                      fontSize: { xs: "2.4rem", sm: "3.2rem", md: "4rem" },
                      mb: 1,
                      textShadow: "2px 4px 16px rgba(0,0,0,0.6)",
                      fontWeight: 800,
                      lineHeight: 1.1,
                      letterSpacing: "-0.5px",
                    }}
                  >
                    We Build The Engine
                  </MKTypography>

                  <MKTypography
                    variant="overline"
                    color="white"
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "0.75rem" },
                      letterSpacing: "0.18em",
                      opacity: 0.65,
                      mb: 3,
                      display: { xs: "none", md: "block" },
                    }}
                  >
                    The DevHouse
                  </MKTypography>

                  <MKTypography
                    variant="h6"
                    color="white"
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: "1rem", sm: "1.15rem" },
                      textShadow: "1px 1px 4px rgba(0,0,0,0.5)",
                      lineHeight: 1.7,
                      opacity: 0.92,
                      maxWidth: 560,
                      mb: 4,
                    }}
                  >
                    We design and build custom software that becomes the
                    operational backbone of your business — replacing fragmented
                    tools with a single, intelligent system built around how you
                    actually work.
                  </MKTypography>

                  <MKButton
                    variant="contained"
                    onClick={() =>
                      window.dispatchEvent(new Event("openConsultation"))
                    }
                    sx={{
                      width: { xs: "100%", sm: 220, md: 260 },
                      maxWidth: 320,
                      background:
                        "linear-gradient(135deg,#4e89ff 0%,#1638d1 100%)",
                      color: "#fff",
                      fontWeight: 700,
                      borderRadius: 3,
                      py: 1.2,
                      px: 3,
                      boxShadow: "0 8px 24px rgba(22,56,209,0.28)",
                      fontSize: "0.95rem",
                      textTransform: "none",
                      "&:hover": {
                        boxShadow: "0 12px 36px rgba(22,56,209,0.42)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    Book a Consultation
                  </MKButton>
                </Box>
              </Grid>
            </Grid>
          </Container>

          <Box
            sx={{
              position: "absolute",
              bottom: { xs: 20, md: 28 },
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.8,
              cursor: "default",
              userSelect: "none",
            }}
          >
            <MKTypography
              variant="caption"
              sx={{
                color: "rgba(255,255,255,0.5)",
                letterSpacing: "0.2em",
                fontSize: "0.65rem",
                textTransform: "uppercase",
              }}
            >
              Learn More
            </MKTypography>
            <Box
              sx={{
                animation: "bounceArrow 1.4s ease-in-out infinite",
                "@keyframes bounceArrow": {
                  "0%, 100%": { transform: "translateY(0)", opacity: 0.4 },
                  "50%": { transform: "translateY(6px)", opacity: 1 },
                },
              }}
            >
              <Box
                sx={{
                  width: 22,
                  height: 22,
                  borderRight: "2px solid rgba(255,255,255,0.4)",
                  borderBottom: "2px solid rgba(255,255,255,0.4)",
                  transform: "rotate(45deg)",
                }}
              />
            </Box>
          </Box>
        </MKBox>

        <Box data-ring="light">
          <CaseStudies />
        </Box>

        <Box data-ring="light" sx={{ position: "relative", zIndex: 10 }}>
          <TheThreePrincipals />
        </Box>
        <Box data-ring="dark" sx={{ position: "relative", zIndex: 10 }}>
          <DesignBlocks />
        </Box>
        <Box data-ring="light" sx={{ position: "relative", zIndex: 10 }}>
          <Information />
        </Box>
        <Box data-ring="light" sx={{ position: "relative", zIndex: 10 }}>
          <OdooPartner />
        </Box>

        {open && (
          <MKBox
            onClick={closeModal}
            sx={{
              position: "fixed",
              inset: 0,
              zIndex: 1300,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.5)",
              backdropFilter: "blur(3px)",
              overflow: "hidden",
              overscrollBehavior: "none",
              p: 2,
            }}
          >
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{
                width: { xs: "100%", md: "800px" },
                height: { xs: "75vh", md: "80vh" },
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <ConsultationForm isModal onClose={closeModal} />
            </Box>
          </MKBox>
        )}

        <Box data-ring="dark">
          <Footer />
        </Box>

        {/* <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox> */}
      </div>
    </MKBox>
  );
}

export default Presentation;
